module.exports = __webpack_public_path__ + "img/import.444bf73a.svg";